// 'use client';

// import { useEffect, useRef, useState } from 'react';

// export default function BrandSection() {
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [isVisible, setIsVisible] = useState(false);
//   const [showControl, setShowControl] = useState(false);

//   useEffect(() => {
//     const currentVideo = videoRef.current;
//     if (!currentVideo) return;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         setIsVisible(entry.isIntersecting);
//       },
//       { threshold: 0.5 }
//     );

//     observer.observe(currentVideo);

//     return () => observer.disconnect();
//   }, []);

//   useEffect(() => {
//     const video = videoRef.current;
//     if (!video) return;

//     if (isVisible && isPlaying) {
//       video.play().catch(() => {});
//     } else {
//       video.pause();
//     }
//   }, [isVisible, isPlaying]);

//   const toggleVideo = () => {
//     const video = videoRef.current;
//     if (!video) return;

//     if (video.paused) {
//       video.play().catch(() => {});
//       setIsPlaying(true);
//     } else {
//       video.pause();
//       setIsPlaying(false);
//     }
//   };

//   return (
//     <section className="w-full bg-[#303030] py-16 sm:py-20 lg:py-24">
//       <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
//         <h2 className="text-left text-[28px] font-medium text-[#cfcfcf] sm:text-center sm:text-[36px] lg:text-[44px]">
//           Any color. Perfect match with your interior.
//         </h2>

//         <div className="relative mt-10 sm:mt-14">
//           <div
//             className="group relative aspect-[16/9] overflow-hidden rounded-[5px] bg-black"
//             onMouseEnter={() => setShowControl(true)}
//             onMouseLeave={() => setShowControl(false)}
//           >
//             <video
//               ref={videoRef}
//               muted
//               loop
//               playsInline
//               className="h-full w-full object-cover"
//               onPlay={() => setIsPlaying(true)}
//               onPause={() => setIsPlaying(false)}
//             >
//               <source src="/video/brandsection.mp4" type="video/mp4" />
//             </video>

//             <button
//               type="button"
//               onClick={toggleVideo}
//               aria-label={isPlaying ? 'Pause video' : 'Play video'}
//               className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
//                 !isPlaying || showControl ? 'opacity-100' : 'opacity-0'
//               }`}
//             >
//               <div className="flex h-[88px] w-[88px] items-center justify-center rounded-full border border-white/60 bg-black/25 backdrop-blur-md transition-transform duration-200 group-hover:scale-105">
//                 {isPlaying ? (
//                   <div className="flex gap-[6px]">
//                     <span className="block h-[22px] w-[6px] rounded-sm bg-white" />
//                     <span className="block h-[22px] w-[6px] rounded-sm bg-white" />
//                   </div>
//                 ) : (
//                   <div className="ml-1 h-0 w-0 border-y-[12px] border-y-transparent border-l-[20px] border-l-white" />
//                 )}
//               </div>
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

'use client';

import { useEffect, useRef, useState } from 'react';

export default function BrandSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [isPlaying, setIsPlaying] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [showControl, setShowControl] = useState(false);

  useEffect(() => {
    const currentVideo = videoRef.current;
    if (!currentVideo) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    observer.observe(currentVideo);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isVisible && isPlaying) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isVisible, isPlaying]);

  const startHideTimer = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }

    hideTimeoutRef.current = setTimeout(() => {
      setShowControl(false);
    }, 2000);
  };

  const handleInteraction = () => {
    setShowControl(true);
    startHideTimer();
  };

  const toggleVideo = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play().catch(() => {});
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }

    handleInteraction();
  };

  useEffect(() => {
    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, []);

  return (
    <section data-component-id="src/components/ui/BrandSection.tsx:180:4" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="180" data-component-end-line="226" data-component-file="BrandSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20bg-%5B%23303030%5D%20py-16%20sm%3Apy-20%20lg%3Apy-24%22%7D" className="w-full bg-[#303030] py-16 sm:py-20 lg:py-24">
      <div data-component-id="src/components/ui/BrandSection.tsx:181:6" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="181" data-component-end-line="225" data-component-file="BrandSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mx-auto%20max-w-%5B1440px%5D%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8">
        <h2 data-component-id="src/components/ui/BrandSection.tsx:182:8" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="182" data-component-end-line="184" data-component-file="BrandSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-left%20text-%5B28px%5D%20font-medium%20text-%5B%23cfcfcf%5D%20sm%3Atext-center%20sm%3Atext-%5B36px%5D%20lg%3Atext-%5B44px%5D%22%2C%22textContent%22%3A%22Any%20color.%20Perfect%20match%20with%20your%20interior.%22%7D" className="text-left text-[28px] font-medium text-[#cfcfcf] sm:text-center sm:text-[36px] lg:text-[44px]">
          Any color. Perfect match with your interior.
        </h2>

        <div data-component-id="src/components/ui/BrandSection.tsx:186:8" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="186" data-component-end-line="224" data-component-file="BrandSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20mt-10%20sm%3Amt-14%22%7D" className="relative mt-10 sm:mt-14">
          <div data-component-id="src/components/ui/BrandSection.tsx:187:10" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="187" data-component-end-line="223" data-component-file="BrandSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22group%20relative%20aspect-%5B16%2F9%5D%20overflow-hidden%20rounded-%5B5px%5D%20bg-black%22%7D"
            className="group relative aspect-[16/9] overflow-hidden rounded-[5px] bg-black"
            onMouseMove={handleInteraction}
            onClick={handleInteraction}
          >
            <video data-component-id="src/components/ui/BrandSection.tsx:192:12" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="192" data-component-end-line="202" data-component-file="BrandSection.tsx" data-component-name="video" data-component-content="%7B%22elementName%22%3A%22video%22%2C%22className%22%3A%22h-full%20w-full%20object-cover%22%7D"
              ref={videoRef}
              muted
              loop
              playsInline
              className="h-full w-full object-cover"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            >
              <source data-component-id="src/components/ui/BrandSection.tsx:201:14" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="201" data-component-end-line="201" data-component-file="BrandSection.tsx" data-component-name="source" data-component-content="%7B%22elementName%22%3A%22source%22%2C%22src%22%3A%22%2Fvideo%2Fbrandsection.mp4%22%2C%22type%22%3A%22video%2Fmp4%22%7D" src="/video/brandsection.mp4" type="video/mp4" />
            </video>

            <button data-component-id="src/components/ui/BrandSection.tsx:204:12" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="204" data-component-end-line="222" data-component-file="BrandSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
              type="button"
              onClick={toggleVideo}
              aria-label={isPlaying ? 'Pause video' : 'Play video'}
              className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
                !isPlaying || showControl ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div data-component-id="src/components/ui/BrandSection.tsx:212:14" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="212" data-component-end-line="221" data-component-file="BrandSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20h-%5B88px%5D%20w-%5B88px%5D%20items-center%20justify-center%20rounded-full%20border%20border-white%2F60%20bg-black%2F25%20backdrop-blur-md%20transition-transform%20duration-200%20group-hover%3Ascale-105%22%7D" className="flex h-[88px] w-[88px] items-center justify-center rounded-full border border-white/60 bg-black/25 backdrop-blur-md transition-transform duration-200 group-hover:scale-105">
                {isPlaying ? (
                  <div data-component-id="src/components/ui/BrandSection.tsx:214:18" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="214" data-component-end-line="217" data-component-file="BrandSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-%5B6px%5D%22%7D" className="flex gap-[6px]">
                    <span data-component-id="src/components/ui/BrandSection.tsx:215:20" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="215" data-component-end-line="215" data-component-file="BrandSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22block%20h-%5B22px%5D%20w-%5B6px%5D%20rounded-sm%20bg-white%22%7D" className="block h-[22px] w-[6px] rounded-sm bg-white" />
                    <span data-component-id="src/components/ui/BrandSection.tsx:216:20" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="216" data-component-end-line="216" data-component-file="BrandSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22block%20h-%5B22px%5D%20w-%5B6px%5D%20rounded-sm%20bg-white%22%7D" className="block h-[22px] w-[6px] rounded-sm bg-white" />
                  </div>
                ) : (
                  <div data-component-id="src/components/ui/BrandSection.tsx:219:18" data-component-path="src/components/ui/BrandSection.tsx" data-component-line="219" data-component-end-line="219" data-component-file="BrandSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22ml-1%20h-0%20w-0%20border-y-%5B12px%5D%20border-y-transparent%20border-l-%5B20px%5D%20border-l-white%22%7D" className="ml-1 h-0 w-0 border-y-[12px] border-y-transparent border-l-[20px] border-l-white" />
                )}
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
